import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { getDashboardUrl } from './runtime-config';
import { readStoredOrgId } from './auth.service';

export interface ConversationListApiItem {
  convId: string;
  status: 'NEW' | 'ACTIVE' | 'PENDING' | 'CLOSED' | string;
  agentRequired?: boolean;
  handledBy?: 'bot' | 'human' | string;
  humanAgent?: boolean;
  lastMessage: string;
  lastMessageStatus: 'SENT' | 'DELIVERED' | 'READ' | 'RECEIVED' | string;
  lastMessageTs: string;
  phoneNumber: string;
  contactLabel: string;
  messages: ConversationApiMessage[];
}

export interface ConversationApiMessage {
  direction: 'INBOUND' | 'OUTBOUND' | string;
  messageType?: string;
  text?: string;
  content?: string;
  interactive?: {
    type?: string;
    buttons?: Array<{ id: string; title: string }>;
    id?: string;
    title?: string;
  };
  media?: {
    type?: string;
    url?: string;
  };
  timestamp: string;
  status: 'SENT' | 'DELIVERED' | 'READ' | 'RECEIVED' | string;
}

interface ConversationListApiResponse {
  data: ConversationListApiItem[];
}

@Injectable({ providedIn: 'root' })
export class ConversationListApiService {
  constructor(private readonly http: HttpClient) {}

  async listContacts(): Promise<ConversationListApiItem[]> {
    const endpoint = `${getDashboardUrl()}/api/webapp/whatsapp-dashboard/${encodeURIComponent(readStoredOrgId())}`;
    const response = await firstValueFrom(
      this.http.get<ConversationListApiResponse>(endpoint)
    );
    return response?.data ?? [];
  }
}
